import { render, staticRenderFns } from "./Swiper.vue?vue&type=template&id=167df3a0&"
import script from "./Swiper.vue?vue&type=script&lang=ts&"
export * from "./Swiper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports